var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortfolioOffensiveModerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8585_626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#80E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 0C130.254 2.1171e-07 147.755 4.20177 163.574 12.2618C179.393 20.3218 193.079 32.0111 203.514 46.3742C213.95 60.7372 220.838 77.366 223.615 94.9011C226.392 112.436 224.98 130.38 219.494 147.264C214.008 164.149 204.603 179.496 192.05 192.049C179.496 204.603 164.149 214.008 147.264 219.494C130.38 224.98 112.436 226.392 94.9012 223.615C77.3661 220.838 60.7372 213.95 46.3742 203.514L112.5 112.5L112.5 0Z",
    fill: "#1D873E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8585_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolioOffensiveModerate);
export default __webpack_public_path__ + "static/media/icon--portfolio--offensive-moderate.30bfd442e2fb7e68f2bc9ddf0140aca0.svg";
export { ForwardRef as ReactComponent };